import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { ProblemSection } from './components/ProblemSection';
import { ProductSection } from './components/ProductSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1670056917527791');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1670056917527791&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-brand-darkBg text-slate-200 selection:bg-brand-blue selection:text-white font-sans" data-id="element-0">
      <main className="overflow-hidden" data-id="element-1">
        <Hero data-id="element-2" />
        <Stats data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <ProductSection data-id="element-5" />
        <PricingSection data-id="element-6" />
        <FAQSection data-id="element-7" />
        <FinalCTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
      <PurchaseNotification data-id="element-10" />
    </div>;
}